// Generated by purs version 0.15.0
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Restaumatic_Menu_V2_Memo from "../Restaumatic.Menu.V2.Memo/index.js";
import * as Restaumatic_Menu_V2_Parametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_MenuCatalogue from "../Restaumatic.Menu.V2.Types.MenuCatalogue/index.js";
import * as Restaumatic_Menu_V2_Types_Modifier from "../Restaumatic.Menu.V2.Types.Modifier/index.js";
import * as Restaumatic_Menu_V2_Types_ParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
import * as Restaumatic_Menu_V2_Types_Product from "../Restaumatic.Menu.V2.Types.Product/index.js";
import * as Restaumatic_Menu_V2_Types_ProductCategory from "../Restaumatic.Menu.V2.Types.ProductCategory/index.js";
import * as Restaumatic_UnwrapOperators from "../Restaumatic.UnwrapOperators/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var modifierItemParameters = function (item) {
    return Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))([ Restaumatic_Menu_V2_Parametric.parametricParams(Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifierItem(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "availableWhen";
        }
    })()))(Type_Proxy["Proxy"].value)(item)), Restaumatic_Menu_V2_Parametric.parametricParams(Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifierItem(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "price";
        }
    })()))(Type_Proxy["Proxy"].value)(item)) ]);
};
var modifierParameters = function (catalogue) {
    return function (modifierId) {
        var go = function (modifier) {
            var items = Control_Bind.bind(Control_Bind.bindArray)(Data_Record.getField(Restaumatic_Menu_V2_Types_Modifier.hasFieldModifier(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "sections";
                }
            })()))(Type_Proxy["Proxy"].value)(modifier))(Restaumatic_UnwrapOperators.composeFlippedUnwrapArg()(function (v) {
                return v.items;
            })(Data_Map_Ordered.values));
            var itemsParams = Data_Foldable.foldMap(Data_Foldable.foldableArray)(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))(modifierItemParameters)(items);
            var editableParams = Restaumatic_Menu_V2_Parametric.parametricParams(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(modifier)(function (v) {
                return v.userEditableWhen;
            }));
            var availableParams = Restaumatic_Menu_V2_Parametric.parametricParams(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(modifier)(function (v) {
                return v.availableWhen;
            }));
            return Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))([ availableParams, editableParams, itemsParams ]);
        };
        return Restaumatic_Menu_V2_Memo.memoLookup(Restaumatic_Menu_V2_Memo.ordParametersMemoKey)(Restaumatic_Menu_V2_Memo.parametersMemo(catalogue))(new Restaumatic_Menu_V2_Memo.ModifierParameters(modifierId))(function (v) {
            return Data_Maybe.maybe(Data_Set.empty)(go)(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(modifierId)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Memo.hasFieldMenuCatalogueMemo(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "modifiers";
                }
            })())))(Type_Proxy["Proxy"].value)(catalogue))));
        });
    };
};
var fromCustomParameterId = function (v) {
    if (v instanceof Restaumatic_Menu_V2_Types_ParameterId.CustomParameter) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var directProductCategoryParameters = function (catalogue) {
    return function (category) {
        var modifierParams = Data_Set.unions(Data_Foldable.foldableArray)(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId)(Data_Functor.map(Data_Functor.functorArray)(modifierParameters(catalogue))(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(category)(function (v) {
            return v.categoryModifiers;
        })));
        var divivsibleParams = Restaumatic_Menu_V2_Parametric.parametricParams(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(category)(function (v) {
            return v.divisible;
        }));
        return Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))([ modifierParams, divivsibleParams ]);
    };
};
var directParameterParams = function (parameter) {
    return Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))(Data_Functor.map(Data_Functor.functorArray)(Restaumatic_Menu_V2_Parametric.parametricParams)(Restaumatic_UnwrapOperators.mapUnwrap(Data_Functor.functorArray)()(function (v) {
        return v.availableWhen;
    })(Data_Map_Ordered.values(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(parameter)(function (v) {
        return v.choices;
    })))));
};
var allModifiers = function (catalogue) {
    return function (product) {
        var category = Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "category";
            }
        })()))(Type_Proxy["Proxy"].value)(product))(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Memo.hasFieldMenuCatalogueMemo(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "categories";
            }
        })())))(Type_Proxy["Proxy"].value)(catalogue)));
        return Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Maybe.maybe([  ])(function (v) {
            return Data_Record.getField(Restaumatic_Menu_V2_Types_ProductCategory.hasFieldProductCategory(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "categoryModifiers";
                }
            })()))(Type_Proxy["Proxy"].value)(v);
        })(category))(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "productModifiers";
            }
        })()))(Type_Proxy["Proxy"].value)(product));
    };
};
var directProductParameters = function (catalogue) {
    return function (product) {
        var priceParams = Restaumatic_Menu_V2_Parametric.parametricParams(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(product)(function (v) {
            return v.price;
        }));
        var modifierSettingsParams = Data_Foldable.foldMap(Data_List_Types.foldableList)(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))(function (settings) {
            return Data_Semigroup.append(Data_Set.semigroupSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))(Restaumatic_Menu_V2_Parametric.parametricParams(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldModifierSettings(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "editable";
                }
            })()))(Type_Proxy["Proxy"].value)(settings)))(Restaumatic_Menu_V2_Parametric.parametricParams(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldModifierSettings(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "inputRequired";
                }
            })()))(Type_Proxy["Proxy"].value)(settings)));
        })(Data_Map_Internal.values(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Types_Product.hasFieldProduct(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "modifierSettings";
            }
        })()))(Type_Proxy["Proxy"].value)(product))));
        var modifierParams = Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))(Data_Functor.map(Data_Functor.functorArray)(modifierParameters(catalogue))(allModifiers(catalogue)(product)));
        var categoryDivivsibleParams = Data_Maybe.fromMaybe(Data_Set.empty)(Data_Functor.map(Data_Maybe.functorMaybe)(Restaumatic_UnwrapOperators.composeFlippedUnwrapArg()(function (v) {
            return v.divisible;
        })(Restaumatic_Menu_V2_Parametric.parametricParams))(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(product)(function (v) {
            return v.category;
        }))(Restaumatic_UnwrapOperators.applyUnwrapFlipped()(catalogue)(function (v) {
            return Data_Record.getField(Restaumatic_Menu_V2_Memo.hasFieldMenuCatalogueMemo(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "categories";
                }
            })())))(Type_Proxy["Proxy"].value)(v);
        }))));
        var availabilityParams = Restaumatic_Menu_V2_Parametric.parametricParams(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(product)(function (v) {
            return v.variants;
        }));
        return Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))([ priceParams, availabilityParams, modifierParams, categoryDivivsibleParams, modifierSettingsParams ]);
    };
};
var addDirectlyTransitiveParams = function (catalogue) {
    return function (initial) {
        var lookupTransitiveParams = function (parameterId) {
            return Restaumatic_Menu_V2_Memo.memoLookup(Restaumatic_Menu_V2_Memo.ordParametersMemoKey)(Restaumatic_Menu_V2_Memo.parametersMemo(catalogue))(new Restaumatic_Menu_V2_Memo.ParameterParameters(parameterId))(function (v) {
                return Data_Maybe.maybe(Data_Set.empty)(directParameterParams)(Restaumatic_UnwrapOperators.applyUnwrappedFlipped()(Data_Record.getField(Restaumatic_Menu_V2_Memo.hasFieldMenuCatalogueMemo(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "customParameters";
                    }
                })())))(Type_Proxy["Proxy"].value)(catalogue))(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(parameterId)));
            });
        };
        var customParams = function (params) {
            return Data_Set.fromFoldable(Data_Foldable.foldableArray)(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Data_Array.catMaybes(Data_Functor.map(Data_Functor.functorArray)(fromCustomParameterId)(Data_Array.fromFoldable(Data_Set.foldableSet)(params))));
        };
        return Data_Semigroup.append(Data_Set.semigroupSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))(initial)(Data_Array.fold(Data_Set.monoidSet(Restaumatic_Menu_V2_Types_ParameterId.ordParameterId))(Data_Functor.map(Data_Functor.functorArray)(lookupTransitiveParams)(Data_Array.fromFoldable(Data_Set.foldableSet)(customParams(initial)))));
    };
};
var withTransitiveParams = function ($copy_catalogue) {
    return function ($copy_params) {
        var $tco_var_catalogue = $copy_catalogue;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(catalogue, params) {
            var paramsNext = addDirectlyTransitiveParams(catalogue)(params);
            var $19 = Data_Eq.eq(Data_Set.eqSet(Restaumatic_Menu_V2_Types_ParameterId.eqParameterId))(params)(paramsNext);
            if ($19) {
                $tco_done = true;
                return params;
            };
            $tco_var_catalogue = catalogue;
            $copy_params = paramsNext;
            return;
        };
        while (!$tco_done) {
            $tco_result = $tco_loop($tco_var_catalogue, $copy_params);
        };
        return $tco_result;
    };
};
var productCategoryParameters = function (catalogue) {
    var $20 = withTransitiveParams(catalogue);
    var $21 = directProductCategoryParameters(catalogue);
    return function ($22) {
        return $20($21($22));
    };
};
var productParametersUncached = function (catalogue) {
    var $23 = withTransitiveParams(catalogue);
    var $24 = directProductParameters(catalogue);
    return function ($25) {
        return $23($24($25));
    };
};
var productParameters = function (catalogue) {
    return function (productId) {
        return Restaumatic_Menu_V2_Memo.memoLookup(Restaumatic_Menu_V2_Memo.ordParametersMemoKey)(Restaumatic_Menu_V2_Memo.parametersMemo(catalogue))(new Restaumatic_Menu_V2_Memo.ProductParameters(productId))(function (v) {
            return Data_Maybe.maybe(Data_Set.empty)(productParametersUncached(catalogue))(Data_Map_Internal.lookup(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(productId)(Data_Newtype.unwrap()(Data_Record.getField(Restaumatic_Menu_V2_Memo.hasFieldMenuCatalogueMemo(Restaumatic_Menu_V2_Types_MenuCatalogue.hasFieldMenuCatalogue(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "products";
                }
            })())))(Type_Proxy["Proxy"].value)(catalogue))));
        });
    };
};
export {
    productParameters,
    productParametersUncached,
    productCategoryParameters,
    directProductParameters,
    directProductCategoryParameters,
    modifierParameters,
    modifierItemParameters,
    allModifiers,
    directParameterParams,
    withTransitiveParams,
    addDirectlyTransitiveParams,
    fromCustomParameterId
};
//# sourceMappingURL=index.js.map
